import React, { useEffect, useState } from "react";
import { getApiBaseUrl, authenticatedRequest } from './Utils.js'
import { useAuth } from "./AuthContext";

const UserPermissions = (props) => {

  const authUser = useAuth();
  const [apiURL, setApiUrl] = useState(null);
  const [userToCopyFrom, setUserToCopyFrom] = useState("");
  const [userToChange, setUserToChange] = useState("");
  const [restoreToken, setRestoreToken] = useState("");

  const [output1, setOutput1] = useState("");

  useEffect(() => {
    if (authUser && authUser.access_token) {
      getApiBaseUrl(setApiUrl, authUser.access_token);
    }
  }, [authUser]);

  if (!authUser) {
    sessionStorage.setItem("app:redirect", location.href);
    window.location.replace('/');
    return null;
  }

  const copyGroups = () => {
    const url = `${apiURL}/api/copy-groups/${userToCopyFrom}/${userToChange}`;
    authenticatedRequest(url, authUser.access_token, (response) => {
      setOutput1(response.message);
      setRestoreToken(response.token);
    }, (response) => {
      response.text().then(r => {
        console.log("Error: " + JSON.stringify(r));
        alert("Error: " + JSON.stringify(r));
      });
    });
  }

  const removeUserReg = () => {
    const url = `${apiURL}/api/remove-user-registration/${userToChange}`;
    authenticatedRequest(url, authUser.access_token, (response) => {
      alert(JSON.stringify(response));
    }, (response) => {
      alert("Error: " + response.statusText);
    });
  }

  const restoreUserReg = () => {
    const url = `${apiURL}/api/restore-user-registration/${userToChange}/${restoreToken}`;
    authenticatedRequest(url, authUser.access_token, (response) => {
      alert(JSON.stringify(response));
    }, (response) => {
      alert("Error: " + response.statusText);
    });
  }

  const restoreGroups = () => {
    const url = `${apiURL}/api/restore-user-groups/${userToChange}/${restoreToken}`;
    authenticatedRequest(url, authUser.access_token, (response) => {
      alert(JSON.stringify(response));
    }, (response) => {
      alert("Error: " + response.statusText);
    });
  }

  return (
    <div>
        <div>
          <div className="container-fluid">
            <div className="row">
              <div className='text-center'>
                <h4>Hello, {authUser ? authUser.profile.given_name : "[loading]"}!</h4>
              </div>
            </div>


            <div className='row'>

              <label className="col-lg" style={{ marginLeft: 20 }}>
                User ID of the user to modify (you):
                <input className="form-control" key={"userToChange"} value={userToChange} onChange={(ev) => { setUserToChange(ev.target.value); }} />
              </label>


              <label className="col-lg" style={{ margin: 20 }}>
                The user ID to copy groups from:
                <input className="form-control" key={"userToCopyFrom"} value={userToCopyFrom} onChange={(ev) => { setUserToCopyFrom(ev.target.value); }} />
              </label>

            </div>
          </div>

          <div className='row' style={{ marginLeft: 20 }}>
            <div className='col-lg'>
              <label>
                Step 1: Set your primary group to User Registration (or if using this tool for someone other than yourself, set their primary group to the desired primary group)
              </label>
            </div>
          </div>

          <div className='row' style={{ marginLeft: 20 }}>

            <div className='col-sm'>
              <button className="btn btn-raised btn-primary" id="copyGroups" onClick={copyGroups}>Step 2: Copy Groups</button>
            </div>
            <div className='col-sm'>
              {output1 ? <label>{output1}. You can copy your group restore token from below and save it for later in case this page reloads or you plan to test for an extended time.</label> : ""}
            </div>
          </div>

          <div className='row' style={{ marginLeft: 20 }}>
            <label>
              Step 3: Set your new primary group
            </label>
          </div>

          <div className='row' style={{ marginLeft: 20 }}>
            <button className="btn btn-raised btn-primary" id="removeUserReg" onClick={removeUserReg}>Step 4: Remove Your User Registration group</button>
          </div>

          <div className='row' style={{ marginLeft: 20 }}>
            <label>
              Step 5: Do your tests
            </label>
          </div>

          <div className='row' style={{ marginLeft: 20 }}>
            <label className="col-lg">
              Group restore token:
              <input className="form-control" key={"restoreToken"} size={150} value={restoreToken} onChange={(ev) => { setRestoreToken(ev.target.value); }} />
            </label>
          </div>

          <div className='row' style={{ marginLeft: 20 }}>
            <button className="btn btn-raised btn-primary" id="restoreUserReg" onClick={restoreUserReg}>Step 6: Restore your User Registration group</button>
          </div>

          <div className='row' style={{ marginLeft: 20 }}>
            <label>
              Step 7: Set your primary group to User Registration
            </label>
          </div>

          <div className='row' style={{ marginLeft: 20 }}>
            <button className="btn btn-raised btn-primary" id="restoreGroups" onClick={restoreGroups}>Step 8: Restore your groups</button>
          </div>

          <div className='row' style={{ marginLeft: 20 }}>
            <label>
              Step 9: Restore your primary group to what it used to be before you started.
            </label>
          </div>
        </div>
    </div >
  )
}
export default UserPermissions;